"use strict";

var _defineProperty = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.useTriggerTransition = void 0;

var _react = require("react");

var _gatsby = require("gatsby");

var _createTransitionContext = require("../context/createTransitionContext");

var _triggerTransition = require("../utils/triggerTransition");

var useTriggerTransition = function useTriggerTransition(defaultOptions) {
  var context = (0, _react.useContext)(_createTransitionContext.Context);

  var programmaticallyTriggerTransition = function programmaticallyTriggerTransition(calledOptions) {
    // allow passing an event directly instead of options
    if (calledOptions instanceof Event || calledOptions.nativeEvent && calledOptions.nativeEvent instanceof Event) {
      calledOptions = {
        event: calledOptions
      };
    }

    var options = _objectSpread(_objectSpread({}, defaultOptions), calledOptions);

    if (context.disableAnimation) {
      // If the user has set their browser or OS to prefers-reduced-motion
      // we should respect that.
      if (options.event) {
        options.event.persist();
        options.event.preventDefault();
      }

      (0, _gatsby.navigate)(options.to);
    } else {
      (0, _triggerTransition.triggerTransition)(_objectSpread(_objectSpread({}, context), options));
    }
  };

  return programmaticallyTriggerTransition;
};

exports.useTriggerTransition = useTriggerTransition;